import { useDispatch, useSelector } from 'react-redux';
import Cloudes from '../../shared/ui/Cloudes/Cloudes';
import cls from './Start.module.scss';
import { setPage } from '../../shared/redux/pages/slice';
import { Pages } from '../../shared/redux/pages/types';
import Sound from '../../shared/ui/Sound/Sound';
import trenerImg from '../../shared/assets/images/trener.svg';
import GetText from '../../shared/ui/GetText/GetText';
import { RootState } from '../../shared/redux/store';
import buttonMp3 from '../../shared/assets/sound/button_2.mp3';

const soundButton = new Howl({
  src: [buttonMp3],
});

const Start = () => {
  const dispatch = useDispatch();
  const isSound = useSelector((state: RootState) => state.sound.isSound);
  return (
    <div className={cls.Start}>
      <img alt="Mentor" className={cls.trenerImage} src={trenerImg} />
      <Cloudes />
      <div className={cls.container}>
        <GetText text="Великий" size={42} type="h1" />
        <GetText text="Наставник" size={28} type="h2" />

        <div className={cls.text}>
          <p className={cls.second_p}>
            Только ты можешь <br /> довести людей до цели
          </p>
          <p className={cls.first_p}>
            Только ты можешь <br /> довести людей до цели
          </p>
        </div>
        <button
          onClick={() => {
            if (isSound) {
              soundButton.play();
            }
            dispatch(setPage(Pages.ONBOARDING));
          }}>
          <p>Играть</p>
        </button>
      </div>
      <Sound />
    </div>
  );
};

export default Start;
